import { render, staticRenderFns } from "./CargaHorariaAulasTeoricas.vue?vue&type=template&id=9759a844"
import script from "./CargaHorariaAulasTeoricas.vue?vue&type=script&lang=js"
export * from "./CargaHorariaAulasTeoricas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports